module.exports = __webpack_public_path__ + "media/images/facebook_logo-f9adb20e325d4a6fb08a6ffb5701962e.png";